import { Item } from "./styled";

const List = ({ children }: { children: any; [key: string]: any }) => children;

List.Item = Item;

export default List;
